import { render, staticRenderFns } from "./materialPriceHistory.vue?vue&type=template&id=8cc7318a&scoped=true"
import script from "./materialPriceHistory.vue?vue&type=script&lang=js"
export * from "./materialPriceHistory.vue?vue&type=script&lang=js"
import style0 from "./materialPriceHistory.vue?vue&type=style&index=0&id=8cc7318a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc7318a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cc7318a')) {
      api.createRecord('8cc7318a', component.options)
    } else {
      api.reload('8cc7318a', component.options)
    }
    module.hot.accept("./materialPriceHistory.vue?vue&type=template&id=8cc7318a&scoped=true", function () {
      api.rerender('8cc7318a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/materialPriceHistory.vue"
export default component.exports